import {useConfig} from '@aboutyou/config';
import {
  useActivateApiAbTestCallback,
  useIsFeatureActive,
} from '@aboutyou/feature-flags';
import {useCallback, useEffect} from 'react';

export const useCategoryLandingPageTest = () => {
  const {device} = useConfig();
  useIsFeatureActive('enable_category_landing_page_test', {
    abTest:
      device === 'desktop'
        ? 'ab_test_setup_landingpage_d'
        : 'ab_test_setup_landingpage',
  });
};

export const useA2bTest = () => {
  const {device} = useConfig();
  const {activateAbTest: activateAbTestBase} =
    useIsFeatureActive('enable_a2b_test');

  const activateAbTest = () => {
    if (device === 'desktop') {
      activateAbTestBase('ab_test_setup_a2b_d');
    } else {
      activateAbTestBase('ab_test_setup_a2b');
    }
  };

  return {activateAbTest};
};

export const useAdpRecoTest = () => {
  const {device} = useConfig();
  const {activateAbTest: activateAbTestBase} = useIsFeatureActive(
    'enable_adp_reco_test',
  );

  const activateAbTest = () => {
    if (device === 'desktop') {
      activateAbTestBase('ab_test_setup_reco_d');
    } else {
      activateAbTestBase('ab_test_setup_reco');
    }
  };

  return {activateAbTest};
};

export const useActivateADPLandingPageApiTest = () => {
  const {device} = useConfig();
  const activateAbTestBase = useActivateApiAbTestCallback();

  return useCallback(() => {
    if (device === 'desktop') {
      activateAbTestBase('ab_be_aa_test_adp_d');
    } else {
      activateAbTestBase('ab_be_aa_test_adp_m');
    }
  }, [activateAbTestBase, device]);
};

export const useActivateADPRecoApiTest = () => {
  const {device} = useConfig();
  const activateAbTestBase = useActivateApiAbTestCallback();

  useEffect(() => {
    if (device === 'desktop') {
      activateAbTestBase('ab_be_aa_test_reco_d');
    } else {
      activateAbTestBase('ab_be_aa_test_reco_m');
    }
  }, [activateAbTestBase, device]);
};
